import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState, useContext } from 'react';
import CustomerInfoCard from './CustomerInfoCard';
import apiService from "../../service/apiService";
import { Button } from 'primereact/button';
import { RTLContext } from '../../App';
import StatusBadge from './StatusBadge';
import * as XLSX from "xlsx";
import { dateFormatter } from "../../utilities/utillFunction";
import { Calendar } from "primereact/calendar";
import moment from "moment";
const OrderDetailsComponent = ({ orderID }) => {
    const serviceId = localStorage.getItem("serviceId");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [orderDetails, setOrderDetails] = useState({});
    const [activeTab, setActiveTab] = useState('items'); // 'items' or 'vendor'
    const { closeSidebar } = useContext(RTLContext);

    const query = {
        filter: { orderID }
    };

    const getData = async () => {
        try {
            let result = await apiService.httpDBService(
                query,
                serviceId,
                "nq-customer-order-transaction"
            );

            if (result?.length) {
                setOrderDetails(result[0]);
            }
        } catch (err) {
            setError("Something went wrong while fetching order details.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setError("");
        setLoading(true);
        setOrderDetails({});
        getData();
    }, [orderID]);

    if (loading) return <div className='grid justify-content-center align-items-center mt-4'>
        <ProgressSpinner style={{ width: '50px', height: '50px', display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }} />
    </div>;

    if (error.length) return <p>{error}</p>;
    const flattenOrders = (orders = []) => {
        if (!Array.isArray(orders)) return [];

        return orders.flatMap((order) => {
            // If lineItems is missing or not an array → skip safely
            if (!Array.isArray(order?.lineItems)) return [];

            return order.lineItems
                .filter(item => item) // remove undefined/null items
                .map((item) => ({
                    orderID: order?.orderID ?? "",
                    orderDate: order?.created_at ?? "",
                    projectName: order?.ProjectName ?? "",
                    currency: order?.currency ?? "",
                    orderStatus: order?.orderStatus ?? "",
                    customerName: order?.customerInfo?.name ?? "",
                    customerEmail: order?.customerInfo?.email ?? "",
                    customerPhone: order?.customerInfo?.mobile ?? "",
                    billingAddress: order?.shipAddress ?? "",
                    designerName: order?.designerInfo?.name ?? "",
                    designerEmail: order?.designerInfo?.email ?? "",
                    lineItemID: item?.lineItemID ?? "",
                    itemName: item?.itemName ?? "",
                    sku: item?.sku ?? "",
                    vendor: item?.vendor ?? "",
                    quantity: item?.quantity ?? 0,
                    unitPrice: item?.unitPrice ?? 0,
                    totalPrice: item?.totalPrice ?? 0,
                    lineItemStatus: item?.status ?? "",
                    lastUpdate: item?.last_update ?? "",
                    paymentMethod: order?.paymentInfo?.method ?? "",
                    paymentStatus: order?.paymentInfo?.status ?? ""
                }));
        });
    };

    const onDownload = () => {
        let result = Array.isArray(orderDetails) ? orderDetails : [orderDetails];
        result = flattenOrders(result)
        let Data = result.map((item) => ({
            "Order No.": item.orderID || "N/A",
            "Project Name": item.projectName || "N/A",
            "Order Date": dateFormatter(
                item.orderDate,
                "MMM DD hh:mm A",
                "YYYY-MM-DD HH:mm:ss"
            ),
            "Order Status": item.orderStatus || "N/A",

            "Customer Name": item.customerName || "N/A",
            "Customer Email": item.customerEmail || "N/A",
            "Customer Phone": item.customerPhone || "N/A",

            "Designer Name": item.designerName || "N/A",
            "Designer Email": item.designerEmail || "N/A",

            "Product Name": item.itemName || "N/A",
            "SKU": item.sku || "N/A",
            "Vendor": item.vendor || "N/A",

            "Quantity": item.quantity || 0,
            "Unit Price": `$${Number(item.unitPrice || 0).toFixed(2)}`,
            "Total Price": `$${Number(item.totalPrice || 0).toFixed(2)}`,
            "Currency": item.currency || "N/A",

            "Billing Address": item.billingAddress || "N/A",
            "Location (Quote File)": item.location || "N/A",

            "Last Updated": dateFormatter(
                item.lastUpdate,
                "MMM DD hh:mm A",
                "YYYY-MM-DD HH:mm:ss"
            )
        }));

        // Create Excel file
        let filename = `orders_${moment().format('YYYY-MM-DD')}.xlsx`;
        let ws = XLSX.utils.json_to_sheet(Data);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Orders");
        XLSX.writeFile(wb, filename);
    };

    return (
        <div className="mt-2 p-3">
            <div className='grid justify-content-between align-items-center mb-2 '>
                <div className='p-0 ml-1 grid align-items-center justify-content-between mt-1' style={{
                    fontFamily: "Inter",
                    fontSize: '16px',
                    fontWeight: '700',
                    color: "black",
                    margin: 0
                }}>
                    <p className='m-0 p-0'>Order #{orderID.substring(0, 4)}</p>
                    <div className='ml-2'><StatusBadge status={orderDetails["orderStatus"]} /></div>
                </div>
                <Button icon="pi pi-times" className="p-button-text p-button-rounded" style={{ color: "black" }} onClick={closeSidebar} aria-label="Close" />
            </div>

            {/* ✅ Customer Info */}
            <CustomerInfoCard
                name={orderDetails?.customerInfo?.name ?? "N/A"}
                email={orderDetails?.customerInfo?.email ?? "N/A"}
                phoneNumber={orderDetails?.customerInfo?.mobile ?? "N/A"}
                numberOfItems={orderDetails?.lineItems?.length ?? 0}
                billingAddress={orderDetails?.shipAddress ?? "N/A"}
            />
            <div className="lg:col-6 col-12 p-0">
                <Button

                    label="Export Order Details"
                    onClick={onDownload}
                    style={{
                        background: "white",
                        height: "40px",
                        boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                        border: "1px solid #ddd",
                        color: "#3d3d3d",
                        borderRadius: "10px",

                        whiteSpace: "nowrap",
                        fontFamily: "Inter"
                    }}
                    className="p-button-outlined col-12 "
                />
            </div>


            {/* ✅ Custom Tabs */}
            <div className="mt-4">
                {/* Tab Headers */}
                <div className="flex gap-2 mb-3 border-bottom-1 border-200">
                    <p
                        className={`cursor-pointer  m-0 ${activeTab === 'items' ? 'custom-tab-active' : 'custom-tab-inactive'}`}
                        onClick={() => setActiveTab('items')}
                        style={{ fontWeight: "700" }}
                    >
                        Item Details
                    </p>
                    {/* <p
                        className={`cursor-pointer py-2 px-3 m-0 ${activeTab === 'vendor' ? 'custom-tab-active' : 'custom-tab-inactive'}`}
                        onClick={() => setActiveTab('vendor')}
                    >
                        Vendor Details
                    </p> */}
                </div>

                {/* Tab Content */}
                {/* ================= ITEM DETAILS ================= */}
                {activeTab === 'items' && (
                    <div className="">
                        {orderDetails?.lineItems?.length ? (
                            <table className="w-full border-collapse">
                                <thead>
                                    <tr>
                                        <th className="text-left item-details-dialog-header">Item Name</th>
                                        <th className="text-left item-details-dialog-header">Vendor</th>
                                        <th className="text-left item-details-dialog-header">Qty</th>
                                        <th className="text-left item-details-dialog-header">Price</th>
                                        <th className="text-left item-details-dialog-header">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderDetails.lineItems.map((item, index) => (
                                        <tr key={index}>
                                            <td className=" item-details-dialog-body">
                                                {item?.itemName??"N/A"}
                                            </td>
                                            <td className=" item-details-dialog-body">
                                                {item?.vendor??"N/A"}
                                            </td>
                                            <td className=" item-details-dialog-body">
                                                {item?.quantity??"N/A"}
                                            </td>
                                            <td className=" item-details-dialog-body">
                                                ${item?.unitPrice??"N/A"}
                                            </td>
                                            <td className=" item-details-dialog-body">
                                                ${item?.totalPrice??"N/A"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>No items found.</p>
                        )}
                    </div>
                )}

                {/* ================= VENDOR DETAILS ================= */}
                {activeTab === 'vendor' && (
                    <div className="p-3 item-details-dialog-body">
                        <div className="mb-3 grid align-items-center">
                            <p className='item-details-dialog-header mr-1'>Vendor Name:</p>
                            {orderDetails?.vendorInfo?.vendorName ?? "N/A"}
                        </div>

                        <div className="mb-3 grid align-items-center">
                            <p className='item-details-dialog-header mr-1'>Vendor Email:</p>
                            {orderDetails?.vendorInfo?.vendorEmail ?? "N/A"}
                        </div>

                        <div className="mb-3 grid align-items-center">
                            <p className='item-details-dialog-header mr-1'>Vendor Phone:</p>
                            {orderDetails?.vendorInfo?.vendorPhone ?? "N/A"}
                        </div>

                        <div className="mb-3 grid align-items-center">
                            <p className='item-details-dialog-header mr-1'>Vendor Address:</p>
                            {orderDetails?.vendorInfo?.vendorAddress ?? "N/A"}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OrderDetailsComponent;